(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-slideshow-v1"] && !Shopify.designMode) return;
  try {
    
(function () {
  var selector = '[data-section-type="section-slideshow-v1"]';

  function initProductRotation(root) {
    root.querySelectorAll('.ih-products-grid').forEach(function (grid) {
      if (grid._ihRotationReady) return;
      grid._ihRotationReady = true;
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.ih-prod-card'));
      if (!cards.length) return;
      var current = 0;
      var picture = grid.closest('.picture-slideshow');
      var linkCard = picture ? picture.querySelector('.ih-product-link-card') : null;
      function updateLinkCard(card) {
        if (!linkCard) return;
        var name = linkCard.querySelector('.ih-prod-card__name');
        var price = linkCard.querySelector('.ih-prod-card__price');
        linkCard.href = card.getAttribute('data-product-url') || '#';
        if (name) name.textContent = card.getAttribute('data-product-name') || '';
        if (price) price.textContent = card.getAttribute('data-product-price') || '';
      }
      cards.forEach(function (card, index) {
        card.classList.toggle('is-active', index === 0);
        card.setAttribute('aria-hidden', index === 0 ? 'false' : 'true');
      });
      updateLinkCard(cards[0]);
      if (cards.length < 2) return;
      grid._ihRotationTimer = setInterval(function () {
        cards[current].classList.remove('is-active');
        cards[current].setAttribute('aria-hidden', 'true');
        current = (current + 1) % cards.length;
        cards[current].classList.add('is-active');
        cards[current].setAttribute('aria-hidden', 'false');
        updateLinkCard(cards[current]);
      }, 3000);
    });
  }

  function init(root, retries) {
    if (!root.isConnected) return;
    initProductRotation(root);
    if (!window.jQuery || !jQuery.fn.slick) {
      if (retries > 0) setTimeout(function () { init(root, retries - 1); }, 100);
      return;
    }
    var slider = jQuery(root).find('.slick-side-h1');
    if (!slider.length) return;
    var options = {autoplay:false, autoplaySpeed:3000, pauseOnHover:false,
      pauseOnFocus:false, arrows:true, dots:true, infinite:true, speed:500,
      slidesToShow:1, slidesToScroll:1, appendArrows:slider,
      responsive:[{breakpoint:768,settings:{arrows:false,dots:true}}]};
    if (slider.hasClass('slick-initialized')) {
      slider.slick('slickSetOption', options, true);
      slider.slick('slickPause');
    } else { slider.slick(options); }

    if (!root._ihResizeBound) {
      root._ihResizeBound = true;
      var resizeTimer;
      var fixSlickWidth = function () {
        if (!root.isConnected || !slider.hasClass('slick-initialized')) return;
        slider.slick('setPosition');
        var listW = slider.find('.slick-list').width();
        var slideW = slider.find('.slick-slide').first().outerWidth();
        if (listW && slideW && Math.abs(listW - slideW) > 2) {
          slider.slick('refresh');
        }
      };
      window.addEventListener('resize', fixSlickWidth);
      window.addEventListener('load', fixSlickWidth);
      if (window.ResizeObserver) new ResizeObserver(function () { requestAnimationFrame(fixSlickWidth); }).observe(root);
    }
  }
  function scan(scope) {
    if (scope.matches && scope.matches(selector)) init(scope,100);
    scope.querySelectorAll(selector).forEach(function(root){init(root,100);});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',function(){scan(document);});
  else scan(document);
  document.addEventListener('shopify:section:load',function(e){scan(e.target);});
  document.addEventListener('shopify:section:unload',function(e){
    e.target.querySelectorAll('.ih-products-grid').forEach(function(grid){
      if (grid._ihRotationTimer) clearInterval(grid._ihRotationTimer);
    });
    if (!window.jQuery || !jQuery.fn.slick) return;
    jQuery(e.target).find('.slick-side-h1.slick-initialized').slick('unslick');
  });
  document.addEventListener('shopify:block:select',function(e){
    if (!window.jQuery || !jQuery.fn.slick) return;
    var slide=e.target.closest('[data-slide-block]');
    if (!slide) return;
    var slider=jQuery(slide).closest('.slick-side-h1');
    if (!slider.hasClass('slick-initialized')) return;
    slider.slick('slickGoTo',Number(slide.getAttribute('data-slick-index')) || 0,true);
    slider.slick('slickPause');
  });
  document.addEventListener('shopify:block:deselect',function(e){
    /* Product rotation continues; the outer content slide remains fixed. */
  });
})();

  } catch(e) { console.error(e); }
})();
})();
